import { render } from "./layout-change.vue?vue&type=template&id=1d3cf448"
import script from "./layout-change.vue?vue&type=script&lang=ts"
export * from "./layout-change.vue?vue&type=script&lang=ts"
script.render = render

export default script